import React, { useCallback, useEffect, lazy } from "react";
import { Route, Switch } from "react-router";
import { ToastContainer } from "react-toastify";
import { history } from "../../";
import withLayout from "../../Components/Hoc/withLayout";
import withoutSidebar from "../../Components/Hoc/withoutSidebar";
import withSidebar from "../../Components/Hoc/withSidebar";
import AppLoading from "../General/AppLoading";
// import StyleGuide from "../General/StyleGuide";
import withTitle from "../Hoc/withTitle";
import AadCallback from "./aad-callback";
import ChangeRequestList from "./Admin/ChangeRequestList";
// import Details from "./Details";
import Frontpage from "./Frontpage";
import OldDomainNotification from "./OldPortal";
// import AdvancedSearch from "./Search/AdvancedSearch";
import SideNav from "./SideNav";
import { Router } from "react-router-dom";
import { userStore } from "../../Store/userStore";
import { useUserGroupInformation } from "../../Hooks/useUserGroupInformation";
import { useBootstrapMarketArea } from "../../Hooks/UseMarketAreaSettings";
import { useGetUserGroupInformation } from "../../Api/azure";
import initApplicationInsights from "../../Helpers/applicationInsights";

declare const APP_INSIGHTS_INSTRUMENTATION_KEY: string;

const AdvancedSearch = lazy(
    () =>
        import(
            /* webpackChunkName: "AdvancedSearch" */ "./Search/AdvancedSearch"
        )
);
const Details = lazy(
    () => import(/* webpackChunkName: "Details" */ "./Details")
);
const StyleGuide = lazy(
    () => import(/* webpackChunkName: "StyleGuide" */ "../General/StyleGuide")
);

const App = () => {
    const setUser = userStore((s) => s.setUser);

    useBootstrapMarketArea({ subscribeToChanges: true });

    const {
        data: queryUser,
        isLoading,
        error,
        isFetching,
        refetch,
        isSuccess,
    } = useGetUserGroupInformation();

    useEffect(() => {
        isSuccess && queryUser && setUser(queryUser);
    }, [queryUser]);

    useEffect(() => {
        initApplicationInsights(APP_INSIGHTS_INSTRUMENTATION_KEY);

        if (history.location.search.indexOf("search") > -1) {
            history.push(history.location.pathname);
        }
        // run only once on mount (matches componentDidMount)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const isUserBrowsingOldDomain = useCallback((): boolean => {
        return window.location.hostname.toLowerCase() === "ib.myoutotec.com";
    }, []);

    if (isUserBrowsingOldDomain()) {
        return <OldDomainNotification />;
    }

    const effectiveUser =
        // user ??
        queryUser;
    const isAuthenticated: boolean = !!effectiveUser?.marketAreas?.length;

    if (isLoading || (!effectiveUser && isFetching)) {
        return <AppLoading />;
    }

    //  if (isError) {
    //     return (
    //       <div style={{ padding: 24 }}>
    //         <h2>We couldn't load your settings.</h2>
    //         <p>{error?.message ?? "Unknown error"}</p>
    //         <button onClick={() => refetch()}>Try again</button>
    //       </div>
    //     );
    //   }

    return isAuthenticated ? (
        <>
            <ToastContainer
                theme="colored"
                hideProgressBar={true}
                position="bottom-right"
                autoClose={5000}
                style={{ zIndex: 100000 }}
            />
            <Router history={history}>
                <Switch>
                    <Route
                        exact
                        path="/"
                        component={withLayout(
                            withSidebar({
                                Content: Frontpage,
                                Sidebar: SideNav,
                            })
                        )}
                    />

                    <Route exact path="/aad-callback" component={AadCallback} />
                    <Route
                        exact
                        path="/search"
                        component={withLayout(
                            withoutSidebar({ Content: AdvancedSearch })
                        )}
                    />
                    <Route
                        exact
                        path="/search/:searchId"
                        component={withLayout(
                            withoutSidebar({ Content: AdvancedSearch })
                        )}
                    />
                    <Route
                        exact
                        path="/adminChangeRequests"
                        component={withLayout(
                            withSidebar({
                                Content: ChangeRequestList,
                                Sidebar: SideNav,
                            })
                        )}
                    />
                    <Route
                        exact
                        path="/styleguide"
                        component={withLayout(
                            withoutSidebar({ Content: StyleGuide })
                        )}
                    />
                    <Route
                        exact
                        path="/:filter"
                        component={withLayout(
                            withSidebar({
                                Content: Frontpage,
                                Sidebar: SideNav,
                            })
                        )}
                    />
                    <Route
                        exact
                        path="/:filter?/:itemType?/:parameter?/:activeFilterParameter?"
                        component={withLayout(
                            withSidebar({
                                Content: Details,
                                Sidebar: SideNav,
                            })
                        )}
                    />
                </Switch>
            </Router>
        </>
    ) : (
        <AppLoading errors={error} />
    );
};

export default withTitle(App) as any;
